import { render, staticRenderFns } from "./disciplinas.vue?vue&type=template&id=1de69cb8"
import script from "./disciplinas.vue?vue&type=script&lang=js"
export * from "./disciplinas.vue?vue&type=script&lang=js"
import style0 from "./disciplinas.vue?vue&type=style&index=0&id=1de69cb8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports